import { Box, Image, useWindowDimensions } from '@jfs/ui-new'
import { isMobileWidth } from '../../util/util'

export const UserNeedTiles = () => {
  const viewportWidth = useWindowDimensions()
  const isMobile = isMobileWidth(viewportWidth)
  return (
    <Box
      w={'100vw'}
      position={isMobile ? undefined : 'absolute'}
      h={isMobile ? undefined : '100vh'}
      flexDirection={isMobile ? 'column' : 'row'}
      justify={'space-evenly'}>
      <Box f={isMobile ? undefined : 0.3}>
        <Box
          position={isMobile ? undefined : 'absolute'}
          top={isMobile ? undefined : '20%'}
          left={isMobile ? 60 : undefined}
          right={isMobile ? undefined : 28}
          pt={isMobile ? 32 : 0}>
          <Image
            source={require('../../assets/svg/send-money-consumer.svg')}
            width={isMobile ? '54vw' : 286}
            height={isMobile ? 40 : 60}
          />
        </Box>
        <Box
          position={isMobile ? undefined : 'absolute'}
          top={isMobile ? undefined : '35%'}
          left={isMobile ? 100 : undefined}
          right={isMobile ? undefined : 72}
          pt={isMobile ? 12 : 0}>
          <Image
            source={require('../../assets/svg/request-money-consumer.svg')}
            width={isMobile ? '58vw' : 310}
            height={isMobile ? 40 : 60}
          />
        </Box>
        <Box
          position={isMobile ? undefined : 'absolute'}
          top={isMobile ? undefined : '52%'}
          left={isMobile ? 60 : undefined}
          right={isMobile ? undefined : -64}
          pt={isMobile ? 12 : 0}>
          <Image
            source={require('../../assets/svg/quick-recharge.svg')}
            width={isMobile ? '50vw' : 268}
            height={isMobile ? 40 : 60}
          />
        </Box>
      </Box>
      {!isMobile && <Box f={isMobile ? undefined : 0.3} />}
      <Box f={isMobile ? undefined : 0.3}>
        <Box
          position={isMobile ? undefined : 'absolute'}
          top={isMobile ? undefined : '52%'}
          right={isMobile ? -100 : '100%'}
          pt={isMobile ? 12 : 0}>
          <Image
            source={require('../../assets/svg/paybill-timely.svg')}
            width={isMobile ? '45vw' : 238}
            height={isMobile ? 40 : 60}
          />
        </Box>
        <Box
          position={isMobile ? undefined : 'absolute'}
          top={isMobile ? undefined : '38%'}
          right={isMobile ? -60 : '75%'}
          pt={isMobile ? 12 : 0}>
          <Image
            source={require('../../assets/svg/paystore.svg')}
            width={isMobile ? '53vw' : 276}
            height={isMobile ? 40 : 60}
          />
        </Box>
      </Box>
    </Box>
  )
}
